export const theme = {
  offBlack: '#18181B',
  offWhite: '#EDEDED',

  mainBg: '#fff',
  text: '#292b2c',
  accent: '#ff6600',
  secondary: '#F5F2F2',
};
